module.exports = __webpack_public_path__ + "static/media/logoNavbar.02d07ba2.png";